<script lang="ts">import { BaseParticle } from "components/cards/particles";
export let container = undefined;
</script>

<style></style>

<BaseParticle  _name="PlaylistParticle" _cssVariablePrefix="playlist-particle" {...container}>
  <div>Playlist Placeholder</div>
</BaseParticle>
